import { render, staticRenderFns } from "./ListaContactos.vue?vue&type=template&id=f95b297a&scoped=true&"
import script from "./ListaContactos.vue?vue&type=script&lang=js&"
export * from "./ListaContactos.vue?vue&type=script&lang=js&"
import style0 from "./ListaContactos.vue?vue&type=style&index=0&id=f95b297a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95b297a",
  null
  
)

export default component.exports